import {
  faFlagSwallowtail,
  faArrowRightLong,
} from '@fortawesome/pro-regular-svg-icons'
import { Flex, Text } from '@mantine/core'

import {
  useQueryGetBookingById,
  useQueryGetAllBookingProducts,
} from '@flecto/core/saas'
import { useTranslation } from '@flecto/translations'
import { type ParameterID } from '@flecto/types'
import { Icon, CardMetric } from '@flecto/ui'

type CardBookingProductsReservedSummaryProps = {
  bookingId?: ParameterID
  previewNewReservedTotal?: number
}

export function CardBookingProductsReservedSummary({
  bookingId,
  previewNewReservedTotal,
}: CardBookingProductsReservedSummaryProps) {
  const { t } = useTranslation('saas', { keyPrefix: 'booking_items' })
  const { data: booking } = useQueryGetBookingById({ bookingId })
  const { data: bookingProducts } = useQueryGetAllBookingProducts({ bookingId })

  if (!booking) {
    return null
  }

  const totalReserved = bookingProducts?.reduce(
    (acc, bookingProduct) => acc + Number(bookingProduct.quantity),
    0
  )

  return (
    <CardMetric>
      <CardMetric.Icon icon={faFlagSwallowtail} color='blue' />
      <CardMetric.Title>{t('label_reserved')}</CardMetric.Title>
      <CardMetric.Value>
        {typeof previewNewReservedTotal !== 'number' ? (
          <Text fw={500}>{totalReserved}</Text>
        ) : (
          <Flex gap='md' align='center'>
            <Text fw={500} color='dimmed'>
              {totalReserved}
            </Text>
            <Icon icon={faArrowRightLong} size='sm' />
            <Text fw={500}>{previewNewReservedTotal}</Text>
          </Flex>
        )}
      </CardMetric.Value>
    </CardMetric>
  )
}
